import {createFileRoute} from '@tanstack/react-router';
import {ConnectedAccountPage} from 'pages/service/ConnectedAccountPage/ConnectedAccountPage';

export const Route = createFileRoute('/_protected/home/service/account')({
  component: ConnectedAccountPage,
  staticData: {crumbKey: 'navigation.connected-account'},
});
